<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-customer-orders-admin></table-customer-orders-admin>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableCustomerOrdersAdmin from './TableGrids/TableCustomerOrdersAdmin.vue'

export default {
    name: 'CustomerOrdersAdmin',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableCustomerOrdersAdmin,
    },
    data() {
        return {
            page: {
                title: "Customer Orders",
            },
            breadcrumbs: [
                { text: "Customer Orders", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>

<style>

</style>
